import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type DigitalAssetModel from './digital-asset.ts';

export default class AssetSummaryModel extends Model {
  // Basic attributes
  @attr declare assetType: string;
  @attr declare createdBy: Record<string, unknown>;
  @attr declare etag: string;
  @attr declare quickSummary: Record<string, unknown>;
  @attr declare summary: Record<string, unknown>;
  @attr declare updatedBy: Record<string, unknown>;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  // Relationships
  @belongsTo('digital-asset', { async: false, inverse: 'assetSummary', polymorphic: true })
  declare digitalAsset: DigitalAssetModel;

  // Computed properties
  get hasSummary(): boolean {
    return Boolean(this.summary && Object.keys(this.summary).length > 0);
  }

  get hasQuickSummary(): boolean {
    return Boolean(this.quickSummary && Object.keys(this.quickSummary).length > 0);
  }

  [Type] = 'asset-summary' as const;
}
